module.exports = __webpack_public_path__ + "img/plusIcon.79c570f2.svg";